import Navigation from '../components/Navigation';
import DocsContent from '../components/docs/DocsContent';
import Footer from '../components/Footer';

export default function DocsPage() {
  return (
    <div className="min-h-screen bg-black flex flex-col">
      <Navigation />
      <div className="flex-1 pt-20">
        <DocsContent />
      </div>
      <Footer />
    </div>
  );
}
